export default __webpack_public_path__ + "static/media/logoNVIDIA_oldIsGold.4f58d50e.png";